import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Anaqueles from "@/pages/Anaqueles";
import Unidosis from "@/pages/Unidosis";

function App() {
    useEffect(() => {
        document.title = "MD Link Cotizador";
    }, []);

    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/anaqueles"
                        element={
                            <ProtectedRoute>
                                <Anaqueles />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/unidosis"
                        element={
                            <ProtectedRoute>
                                <Unidosis />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
                <Toaster position="top-right" richColors closeButton />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
